<template>
  <div class="r-cover z-0 overflow-hidden flex-c">
    <div class="absolute left-4 md:left-8 top-4 md:top-8 max-w-full">
      <Logo
        :color="logoColor"
        :full-max-width="360"
        :full-max-height="80"
      />
    </div>
    <div class="relative w-full max-h-full overflow-auto scrolling-touch">
      <div class="relative w-full max-w-200 mx-auto my-8 px-4 flex flex-col overflow-hidden">
        <div class="pr-10">
          <Heading :heading-obj="homePage.heading" />
          <Subheading :subheading-obj="homePage.subheading" />
        </div>
        <ButtonList class="" />
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Heading from '@/components/Home/Heading.vue'
import Subheading from '@/components/Home/Subheading.vue'
import ButtonList from '@/components/Home/ButtonList.vue'

export default {
  name: 'Home_Centered',

  components: {
    Logo,
    Heading,
    Subheading,
    ButtonList
  },

  props: {
    homePage: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    logoColor() { return this.homePage.logo_slug || 'white' },
  }
}
</script>

